<div class="glass">
    <div #scrollContainer class="glass-content" [innerHTML]="data.terms"></div>
    <div class="glass-footer">
        <app-button 
            class="button"
            iconLeft="fa-solid fa-check"
            [label]="'WebApp.v1.Shared.Buttons.Yes' | translate"
            iconColor="#57DF8E"
            [fontSize]="14"
            [showOutlineOnHover]="false"
            backgroundColor="transparent"
            [waitCursor]="isLoading"
            [disabled]="disableAccept"
            (click)="accept()"></app-button>

        <app-button 
            class="button margin-left-20"
            iconColor="#c53333"
            iconLeft="fa-solid fa-ban"
            [showOutlineOnHover]="false"
            [fontSize]="14"
            [label]="'WebApp.v1.Shared.Buttons.No' | translate"
            backgroundColor="transparent"
            [waitCursor]="isLoading"
            [disabled]="disableReject"
            (click)="reject()"></app-button>
    </div>
</div>